import { UserException } from '@/domain/user/exception/UserException'

export class CannotEditUserException extends UserException {

}
